module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 2